import { IFilter } from '@shared/models/icommons.model';

import LEASE_FILTERS_OVERRIDES from './lease/lease-filters-override';
import PROPERTY_FILTERS_OVERRIDES from './property/property-filters-override';
import AVAILABILITY_FILTERS_OVERRIDES from './availability/availability-filters-override';

export const FILTERS_OVERRIDE: Record<string, Partial<IFilter>> = {
  ...LEASE_FILTERS_OVERRIDES,
  ...PROPERTY_FILTERS_OVERRIDES,
  ...AVAILABILITY_FILTERS_OVERRIDES,
};

export function applyFiltersOverride(filters: IFilter[]): IFilter[] {
  return filters.map(filter => {
    if (FILTERS_OVERRIDE[filter.key]) {
      return { ...filter, ...FILTERS_OVERRIDE[filter.key] };
    }
    return filter;
  });
}
